import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
//import './Header.css';

function Header() {
  const navigate = useNavigate();
  
  const handleLogout = () => {
    localStorage.removeItem('gallery3_authenticated');
    navigate('/', { replace: true });
  };

  return (
    <header class="header-light scroll-light">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="de-flex sm-pt10">
                            <div class="de-flex-col">
                                <div class="de-flex-col">
                                    <div id="logo">
                                        <a href="/home">
                                            <img alt="" class="logo-2" src="images/logosmall.png" width="200" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="de-flex-col header-col-mid">
                                <ul id="mainmenu">
                                    <li>
                                        <a href="/home">Home<span></span></a>
                                    </li>
                                    <li>
                                        <a href="/explore">Explore<span></span></a>
                                        <ul>
                                            <li><a href="/galleries">Galleries</a></li>
                                            <li><a href="/exhibitions">Exhibitions</a></li>
                                            <li><a href="/collections">Collections</a></li>
                                            <li><a href="/explore">NFTs</a></li>
                                            <li><a href="/artists">Artists</a></li>
                                        </ul>
                                    </li>
                                                                     
                                    <li>
                                        <a href="#">Create<span></span></a>
                                        <ul>
                                            <li><a href="/create-single">Single NFT</a></li>
                                            <li><a href="/create-collection">Collection</a></li>
                                            {/*<li><a href="/create-edition">Edition</a></li>*/}
                                            <li><a href="/create-gallery">Gallery</a></li>
                                            <li><a href="/tickets">Tickets NFT</a></li>
                                        </ul>
                                    </li> 
                                    <li>
                                        <a href="/profile">Sell<span></span></a>
                                    </li> 
                                    <li>
                                        <a href="/learn">Learn<span></span></a>
                                    </li>
                                </ul>
                                <div class="menu_side_area">
                                    <a href="wallet.html" class="btn-main btn-wallet"><i class="icon_wallet_alt"></i><span>Connect</span></a>
                                    <span id="menu-btn"></span>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
        </header>
  );
}

export default Header;